import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
});

export const dropdownButton: TRuleWithTheme = ({ theme }) => ({
    border: '1px solid',
    borderColor: theme.colors.inputsBorder,
    borderRadius: '0.25rem',

    padding: '0 0.75rem 0 1rem',

    height: '2.25rem',

    fontSize: '1rem',
});

export const paginationButton: TRuleWithTheme = ({ theme }) => ({
    '--ant-color-primary': theme.colors.accentSecondary,
    '--ant-color-primary-hover': theme.colors.accentSecondary,
    '--ant-pagination-item-active-color': theme.colors.accentSecondary,
    '--ant-pagination-item-active-color-hover': theme.colors.accentSecondary,

    fontSize: '1rem',
});
